import React from 'react';
import { ListGroupItem } from 'reactstrap';
import { Link, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { parse, format } from 'date-fns';

const ListGroupItemNotes = ({
  data,
  options: {
    includeAuthor,
    includeDuration,
    dateFormat,
  },
}) => {
  const params = useParams();
  return (
    <ListGroupItem
      action
      tag={Link}
      to={`/patients/${params.patient_id}/notes/${data.id}/details`}
      className="d-flex justify-content-between align-items-center"
    >
      <span>
        <strong>{data.attributes.createdDate && format(parse(data.attributes.createdDate.split('+')[0]), dateFormat)}</strong>{' - '}

        {includeAuthor &&
          <span className="text-muted">{data.attributes.author} - </span>
        }

        {includeDuration &&
          <span className="text-muted">{data.attributes.sessionDurationMinutes} minutes - </span>
        }

        {data.attributes.note}
      </span>

      <FontAwesomeIcon icon="chevron-right" className="text-muted" />
    </ListGroupItem>
  );
};

ListGroupItemNotes.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    attributes: PropTypes.shape({
      createdDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.instanceOf(Date),
      ]),
      author: PropTypes.string,
      sessionDurationMinutes: PropTypes.number,
      note: PropTypes.string,
    }),
  }).isRequired,
  options: PropTypes.shape({
    includeAuthor: PropTypes.bool,
    includeDuration: PropTypes.bool,
    dateFormat: PropTypes.string,
  }),
};

ListGroupItemNotes.defaultProps = {
  options: {
    includeAuthor: false,
    includeDuration: false,
    dateFormat: 'MM/DD/YY',
  },
};

export default ListGroupItemNotes;
